import { NgClass, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MatIcon } from '@angular/material/icon';

export enum WarningMessageType {
  Warning = 'warning',
  Error = 'error',
  Info = 'info',
  Success = 'success',
}

@Component({
  selector: 'shared-warning-message',
  standalone: true,
  imports: [MatIcon, NgOptimizedImage, NgClass],
  templateUrl: './warning-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarningMessageComponent {
  protected readonly types = WarningMessageType;

  text = input.required<string>();
  subText = input<string>();
  type = input<WarningMessageType>(WarningMessageType.Warning);
  size = input<'big' | 'small'>('big');
  withBorder = input<boolean>(false);
}
